import { render, staticRenderFns } from "./AccountBanner.vue?vue&type=template&id=4c121fcc&scoped=true&"
import script from "./AccountBanner.vue?vue&type=script&lang=ts&"
export * from "./AccountBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBanner.vue?vue&type=style&index=0&id=4c121fcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c121fcc",
  null
  
)

export default component.exports